import Row from "@Containers/components/Row";
import RouteTravelDuration from "@Route/components/Connection/RouteTravelDuration";
import React from "react";
import VehicleTypeIcon from "@Generic/vehicle/VehicleTypeIcon";

interface RouteBusLayoverDurationProps {
    tripDuration: string,
    companyLetterCode: string,
}

const RouteBusLayoverDuration = ({tripDuration, companyLetterCode}: RouteBusLayoverDurationProps) => {
    return (
        <Row className="travel-stations__additional-info">
            <span className="route-travel-details--first-column-large travel-time">
                <RouteTravelDuration
                    travelDuration={tripDuration}
                    customClassName="gb--label gb--label-green"
                />
            </span>
            <span className="gb--label gb--label-default travel-stations__vehicle-type-container">
                <VehicleTypeIcon
                    width="10"
                    height="10"
                    fill="#070c63"
                    className="vehicle-icon"
                />
                {companyLetterCode}
            </span>
        </Row>
    )
}

export default RouteBusLayoverDuration